<!-- <div id="loader" *ngIf="isLoader">
  <div id="shadow"></div>
  <div id="box"></div>
  <h4><b>Loading..</b></h4>
</div> -->

<div *ngIf="body">
  <mat-card style="background: transparent;">
    <mat-card class="card_style">
      <div style="text-align: center; padding-top: 50px;">
        <h1 style="margin-top: -18px;"><b>Market Study - Others</b></h1>
      </div>

      <!-- Excel export -->
      <div style="text-align:left;">
        <div style="margin-bottom: 2%;">
          <img
            class="excel-button"
            src="https://cdn-icons-png.flaticon.com/128/732/732220.png"
            width="35"
            height="35"
            (click)="excelExport()"
          />
        </div>

        <!-- Filters -->
        <div class="d-flex mb-3 flex-wrap gap-3">
          <!-- Industry Type Filter -->
          <div class="filter-dropdown">
            <label class="label-filter">Industry Type:</label>
            <ng-select 
                placeholder="Select Industry Type" 
                class="me-3" 
                [items]="industry_type" 
                [clearable]="true"
                (clear)="industrySelected()" 
                (change)="industrySelected()" 
                [(ngModel)]="search_filter.industry_type" 
                bindLabel="name" 
                bindValue="name">
              </ng-select>
          </div>

          <!-- Country Filter -->
          <div class="filter-dropdown">
            <label class="label-filter">Country:</label>
            <ng-select placeholder="Select Country" class="me-3"
              [items]="country_drop" (change)="countrySelected()"
              [(ngModel)]="search_filter.marketing_country_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>

          <!-- State Filter -->
          <div class="filter-dropdown">
            <label class="label-filter">State:</label>
            <ng-select placeholder="Select State" class="me-3"
              [items]="statedrop" (change)="stateSelected()"
              [(ngModel)]="search_filter.marketing_state_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>

          <!-- Area Filter -->
          <div class="filter-dropdown">
            <label class="label-filter">Area:</label>
            <ng-select placeholder="Select Area" class="me-3"
              [items]="areadrop" (change)="areaSelected()"
              [(ngModel)]="search_filter.marketing_area_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>

          <!-- Customer Name Filter -->
          <div class="filter-dropdown">
            <label class="label-filter">Customer:</label>
            <input type="text" [(ngModel)]="search_filter.customer_name"
              (ngModelChange)="customerSelected()" class="form-control me-3" />
          </div>

          <!-- Customer Type Filter -->
          <div class="filter-dropdown">
            <label class="label-filter ms-3">Type:</label>
            <input type="text" [(ngModel)]="search_filter.customer_type"
              (ngModelChange)="customerSelected()" class="form-control ms-3" />
          </div>
        </div>

        <!-- Data Table -->
        <div class="table-responsive">
          <table class="table table-striped table-hover align-middle" id="MarketStudyOthers">
            <thead>
              <tr>
                <th>Industry Type</th>
                <th>Country</th>
                <th>State</th>
                <th>Area</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Customer</th>
                <th>Type</th>
                <th>Customer Category</th>
                <th>Whatsapp Number</th>
                <th>Owners Nationality</th>
                <th>No Of Painters In Shop</th>
                <th>Shop Old</th>
                <th>Delivery Duration</th>
                <th>Current Supplier 1</th>
                <th>Current Supplier 2</th>
                <th>Current Supplier 3</th>
                <th>Mixing Machine Brand</th>
                <th>Body Filler Brand</th>
                <th>Monthly Business</th>
                <th>No of Staffs</th>
                <th>Sales Staff</th>
                <th>No of Cars Monthly</th>
                <th>No of Panels Monthly</th>
                <th>No of Paint Booth</th>
                <th>Color Mixer</th>
                <th>Existing Credit Terms</th>
                <th>Payment Behaviour</th>
                <th>Abrasive Opportunity</th>
                <th>Created By</th>
                <th>Type Of Work</th>
                <th>2K Primer Brand</th>
                <th>1K Primer Brand</th>
                <th>Clear Coat Brand</th>
                <th>NC Thinner Brand</th>
                <th>2K Thinner Brand</th>
                <th>Abrasive Brand</th>
              </tr>
            </thead>
            <tbody class="table-bordered">
          <tr *ngFor="let employee of output">
            <td>{{ employee?.industry_type }}</td>
            <td>{{ employee?.marketing_country?.name }}</td>
            <td>{{ employee?.marketing_state | json }}</td>
<td>{{ employee?.marketing_area | json }}</td>

            <td>{{ employee?.latitude }}</td>
            <td>{{ employee?.longitude }}</td>
            <td>{{ employee?.customer_name }}</td>
            <td>{{ employee?.customer_type }}</td>
            <td>{{ employee?.customer_category }}</td>
            <td>{{ employee?.whatsapp_number }}</td>
            <td>{{ employee?.owners_nationality }}</td>
            <td>{{ employee?.no_of_painters }}</td>
            <td>{{ employee?.shop_old }}</td>
            <td>{{ employee?.delivery_duration }}</td>
            <td>{{ employee?.current_supplier_name_1 }}</td>
            <td>{{ employee?.current_supplier_name_2 }}</td>
            <td>{{ employee?.current_supplier_name_3 }}</td>
            
            <td>{{ employee?.mixing_machine_brand?.join(', ') }}</td>
            <td>
  <div *ngFor="let brand of employee?.body_filler_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
            <td>{{ employee?.monthly_bussiness }}</td>
            <td>{{ employee?.no_of_staffs }}</td>
            <td>{{ employee?.sales_staff }}</td>
            <td>{{ employee?.no_of_cars_monthly }}</td>
            <td>{{ employee?.no_of_panels_monthly }}</td>
            <td>{{ employee?.no_of_paint_booths }}</td>
            <td>{{ employee?.color_mixer }}</td>
            <td>{{ employee?.existing_credit_terms }}</td>
            <td>{{ employee?.payment_behaviour }}</td>
            <td>{{ employee?.abrasive_opertunity }}</td>
            <td>{{ employee?.created_by?.employee_name }}</td>
            <td>{{ employee?.type_of_work }}</td>
           
            <td>
  <div *ngFor="let brand of employee?.two_k_primer_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
            <td>
  <div *ngFor="let brand of employee?.one_k_primer_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
            <td>
  <div *ngFor="let brand of employee?.clear_coat_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
<td>
  <div *ngFor="let brand of employee?.nc_thinner_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
<td>
  <div *ngFor="let brand of employee?.two_k_thinner_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
<td>
  <div *ngFor="let brand of employee?.abrasive_brand">
    {{ brand?.name }} - {{ brand?.avgMonthlyVolume }} - {{ brand?.price }}
  </div>
</td>
        
          </tr>
        </tbody>
          </table>
        </div>
      </div>
    </mat-card>
  </mat-card>
</div>
